import React from 'react'
import {_L, useLocaleState} from '../../context/LocaleContext'
import BurgerMenu from '../BurgerMenu/BurgerMenu'
import {LOGON_CONTAINER, REGISTER_KIOSK} from '../../constants/const'
import Icons from '../Icons'
import ArchibusLogo from '../../assets/img/archibus-icon-essential.png'
import styled from 'styled-components'
import Search from '../Search/Search'
import {useUserState} from '../../context/UserContext'
import {useUIDispatch, useUIState} from '../../context/UIContext'
import {useConfigState, getAvailableActions} from '../../context/ConfigContext'
import HeaderButton from '../Header/HeaderButton'
import {isServiceCatalog} from '../../utils/routing'
import {isEmpty} from '../../utils/helpers'
import {useViewFetch} from '../../utils/fetch'
import {fetchServiceCatalogTypes} from '../../api/servicerequest'
import {SERVICE_SEQUENCE} from '../../constants/const'
import {DASHBOARD} from '../../constants/const'
import {
  MenuItem,
  MenuLogo,
  MenuButtonContainer,
  MenuItemText
} from '../BurgerMenu/MenuStyles'
import * as Security from '../../api/archibus/SecurityApi'
import MediaQuery from 'react-responsive'

const MainHeader = ({building, parentPage}) => {
  const {user} = useUserState()
  const localeState = useLocaleState()
  const uiDispatch = useUIDispatch()
  const uiState = useUIState()
  const configState = useConfigState()
  const {isKiosk} = uiState

  const {OrganizationName} = configState.params

  const availableActions = getAvailableActions(configState)

  const {workingspace, meetingspace, createrequest, search} = availableActions

  // isCatalogView is true when the Service Catalog is the primary app view.
  const isCatalogView = isServiceCatalog()

  const onHeaderCancel = () => {
    uiDispatch({
      type: 'setContent',
      payload: {content: parentPage || 'DASHBOARD'}
    })
  }

  const onRegisterKiosk = () =>
    uiDispatch({type: 'setContent', payload: {content: REGISTER_KIOSK}})

  const onSignOnButtonClick = async () => {
    await Security.logout()
    uiDispatch({type: 'setContent', payload: {content: LOGON_CONTAINER}})
  }

  const onClickOrganization = e => e.stopPropagation()

  const onServiceRequestsClick = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'SERVICE_MORE_LIST'}
    })

  const onMeetingReservationsClick = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'MEETINGS_MORE_LIST'}
    })

  const onWorkspaceReservationsClick = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'WORKSPACE_MORE_LIST'}
    })

  const showRegisterKiosk =
	user.role === '4 - CLIENT ADMINISTRATOR (ACP)' ||
	user.role === '4 - PARTNER ADMINISTRATOR (ACP)' ||
	user.role === 'ACTIVITY LICENSEE' ||
	user.role === 'SYSTEM ADMINISTRATOR (ACP)' ||
	user.role === 'SYSTEM ADMINISTRATOR' ||
	user.role === 'ARCHIBUS ADMINISTRATOR' ||
	user.role === '4 - PROCESS OWNER' ||
	user.role === '4 - PROCESS OWNER - ESSENTIAL (ACP)' ||
    user.role === '4 - PROCESS OWNER - MODULES (ACP)' ||
    user.role === '4 - PROCESS OWNER - FOUNDATIONS (ACP)' ||
    user.role === '4 - PROCESS OWNER - PROFESSIONAL (ACP)'
    	
  const isGuestUser =
	user.name === 'GUEST'
  
  const {data, error} = useViewFetch({
	    api: fetchServiceCatalogTypes,
	    parameters: {
	      includeActions: true,
	      appParameters: availableActions,
	      localeState
	    },
	    onChangeOf: [],
	    initialState: {data: {}, descriptions: {}}
	  })

  const {data: serviceCatalogTypes, descriptions} = data
  
  const onClickCatalogItem = evt => {
	  if(evt.key == "Enter" || evt.key == " " || !evt.key){
		const adaItem = serviceCatalogTypes['SERVICE DESK - ADA CONTACT US']
		const {
		    ids,
		    children,
		    activityType,
		    probType,
		    hideFields,
		    instructions,
		    isStatic = false
		  } = adaItem
        const catalogHeader = descriptions[ids[ids.length - 1]]
        uiDispatch({
          type: 'setContent',
          payload: {
            content: SERVICE_SEQUENCE,
            parentPage: parent || 'SERVICE_CATALOG',
            props: {
              activityType,
              probType,
              initialForm: 'LOCATION',
              catalogHeader,
              hideFields,
              instructions
            }
          }
        })
	  }
	  } 
  
  const onHomeClick = evt => {
	  if(evt.key == "Enter" || evt.key == " " || !evt.key){
	    uiDispatch({
	      type: 'showSearch',
	      payload: {
	        show: false,
	        type: null,
	        options: {},
	        loaded: false
	      }
	    })
	    //uiDispatch({type: 'setActiveFloor', payload: homeFloor})

	    if (isKiosk) {
	      setShowDepartmentList(true)
	      setShowDetail(false)
	    } else {
	      uiDispatch({type: 'setContent', payload: {content: DASHBOARD}})
	    }
	  }
  }
  
  return (
    <HeaderContainer role="navigation">
	  <HeaderTop onClick={onClickOrganization}>
	    <OrganizationContainer>
		  <OrganizationText href="https://illinois.edu/" target="_blank">{OrganizationName}</OrganizationText>
		</OrganizationContainer>
	  </HeaderTop>
	  
      <MediaQuery query="(max-width: 420px)">
       <HeaderMid role="none presentation">
        <tbody>
          <tr>
            <td>
			  <HeaderLeft>
				<SiteNameText role="link" onClick={onHomeClick} onKeyDown={onHomeClick} tabIndex="0">Facility Access Maps</SiteNameText>
		      </HeaderLeft>
		    </td>
			<td>
			  <HeaderRight>
		        <HeaderButton
		    		id="contact-us"
		    		onKeyDown={onClickCatalogItem}
		    		onClick={onClickCatalogItem}
		    		label={_L({key: 'Contact Us', localeState})}
		    	  />
			  </HeaderRight>
		    </td>
	      </tr>
	    </tbody>
       </HeaderMid>
       <HeaderBottom>
    	<HeaderCenter>{search && <Search />}</HeaderCenter>
       </HeaderBottom>
      </MediaQuery>
      <MediaQuery query="(min-width: 421px)">
      <HeaderBottom>
		<HeaderLeft>
			<SiteNameText role="link" onClick={onHomeClick} onKeyDown={onHomeClick} tabIndex="0">Facility Access Maps</SiteNameText>
		</HeaderLeft>
		<HeaderRight>
        	<HeaderButton
        		id="contact-us"
        		onKeyDown={onClickCatalogItem}
        		onClick={onClickCatalogItem}
        		label={_L({key: 'Contact Us', localeState})}
        	/>
		</HeaderRight>
        <HeaderCenter>{search && <Search />}</HeaderCenter>
       </HeaderBottom>
       </MediaQuery>
    </HeaderContainer>
  )
}

export default MainHeader

const HeaderContainer = styled.nav`
  /*display: grid;
  grid-template-columns: auto 1fr auto;*/
  margin: auto;
  min-height: 100%;
  min-width: 100%;
  align-items: center;
  position: relative;
  border-top: 7px solid #FF552E;
  background-color: #13294b;

  @media (max-width: 1024px) {
    /*grid-template-columns: 220px auto 150px;*/
  }

  @media (max-width: 420px) {
    /*grid-template-columns: auto 1fr;
    grid-template-rows: 30px 55px 1fr;*/
  }
`

const HeaderTop = styled.div`
  height: 30px;
  box-sizing: border-box;
  /*grid-column-start: 1;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 2;*/
  background-color: #eff0f4;
`

const HeaderBottom = styled.div`
  height: 70px;
  
  @media (max-width: 420px) {
	height: 58px;
  }
`

const HeaderMid = styled.table`
  height: 55px;
  width: 100vw;
`

const HeaderCenter = styled.div`
  /*justify-self: center;*/
  box-sizing: border-box;
  /*margin-top: 10px;
  margin-bottom: 10px;
  display: inline-block;
  vertical-align: middle;*/
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translate(-30%, 0%);
  width: calc(100vw - 500px);
  max-width: 450px;
  
  @media (max-width: 768px) {
	width: calc(100vw - 350px);
	position: relative;
	display: inline-block;
	vertical-align: middle;
	margin-top: 10px;
    margin-bottom: 10px;
    top: 0;
    left: 0;
    transform: none;
  }
  
  @media (max-width: 420px) {
	padding: 5px 2px 5px 2px;
    /*grid-column-start: 1;
    grid-column-end: 3;*/
    width: 100vw;
    margin: 0;
    border-bottom: 1px solid white;
  }
`

const HeaderLeft = styled.div`
  box-sizing: border-box;
  padding-left: 30px;
  display: inline-block;
  line-height: 1.05;
  min-width: 170px;
  margin-top: 15px;
  margin-bottom: 15px;
  
  @media (max-width: 768px) {
	width: 190px;
	vertical-align: middle;
	margin-top: 0;
    margin-bottom: 0;
  }
  
  @media (max-width: 420px) {
    padding-left: 5px;
    width: 160px;
  }
`

const HeaderRight = styled.div`
  /*justify-self: right;*/
  box-sizing: border-box;
  padding-right: 30px;
  position:absolute;
  right: 0;
  top: 40px;
  
  @media (max-width: 420px) {
    padding-right: 10px;
    position: static;
    float: right;
  }
`

const OrganizationContainer = styled.div`
  padding: 3px 8px 3px 30px;

  @media (max-width: 420px) {
    padding: 2px 10px 2px 10px;
  }
`

const OrganizationText = styled.a`
  font-weight: 700;
  color: #13294b;
  font-size: 12px;
  letter-spacing: 1.75px;
  text-decoration: none;
  :focus { 
  	outline: 3px solid #FF9900;
  }
  
  @media (max-width: 420px) {
    letter-spacing: .5px;   
  }
`

const SiteNameText = styled.h1`
  font-weight: 700;
  color: #eff0f4;
  font-size: 30px;
  letter-spacing: -0.65px;
  cursor: pointer;
  padding: 5px;
  
  @media (max-width: 768px) {		
    font-size: 26px;
    padding: 0;
  }
  @media (max-width: 420px) {		
    padding: 0 5px 0 5px;
  }
  :focus { 
  	outline: 3px solid #FF9900;
  }
`

const AddressText = styled.div`
  color: #eff0f4;
  font-size: 20px;

  @media (max-width: 1024px) {
    font-size: 18px;
  }
`
const MenuContainer = styled.div`
  display: block;
  padding: 0 8px 0 20px;

  @media (max-width: 420px) {
    padding: 0;
  }
`
